import axios from 'axios';

const API_URL = '/api/v1/users/';
const INVITE = 'invite';
const REGISTER = 'register';
const VERIFY_INVITATION_TOKEN = 'verify-invitation';
const SEARCH = 'search';

const invite = (data) => {
	return axios.post(`${API_URL}${INVITE}`, data);
}

const verifyInvitationToken = (token) => {
	return axios.get(`${API_URL}${VERIFY_INVITATION_TOKEN}/${token}`);
}

const register = (data) => {
	return axios.post(`${API_URL}${REGISTER}`, {
		...data,
	});
}

const searchUsers = ({ filterQuery, pageIndex, pageSize, sortBy }) => {
	return axios.post(`${API_URL}${SEARCH}`, {
		page: pageIndex,
		count: pageSize,
		sortBy,
		filters: [
			{
				type: 'string',
				name: 'fullName',
				value: filterQuery,
			},
			{
				type: 'string',
				name: 'email',
				value: filterQuery,
			},
		],
	});
};

const deleteUserById = (id) => axios.delete(`${API_URL}${id}`);

export {
	invite,
	verifyInvitationToken,
	register,
	searchUsers,
	deleteUserById,
};